import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL_USER || "";
const getConfig = () => ({
    headers: {
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
    },
});

const AnnouncementAdminService = {
    list: () =>
        axios.get(`${baseURL}/announcements/admin`, getConfig()),

    create: (data) =>
        axios.post(`${baseURL}/announcements/admin`, data, getConfig()),

    update: (id, data) =>
        axios.put(`${baseURL}/announcements/admin/${id}`, data, getConfig()),

    remove: (id) =>
        axios.delete(`${baseURL}/announcements/admin/${id}`, getConfig()),
};

export default AnnouncementAdminService;
